import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
  getPaginationRowModel,
} from "@tanstack/react-table";
import { useEffect, useMemo, useState } from "react";
import { INPUT_VARIANT } from "../InputElements/const";
import {
  StyledTable,
  PaginationControls,
  Pagination,
  PaginationInfo,
  PaginationButtonGroup,
  PaginationRowLimit,
  InputPageChange,
  NoDataFound,
  NoDataFound as Loading,
} from "./styles";
import Select from "../InputElements/Select";
import Button from "../Button";
import { generateArray } from "@/util/common_function";
import Loader from "../Loader";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { labels } from "@/util/label";

const columnHelper = createColumnHelper();

// headers = [{key: "headerKeyForData", text: "Header Text"}];
// data = [{...}, {...}];
const Table = ({
  headers = [],
  data = [],
  totalRecords = 0,
  selected = false,
  isAPiCallLoading = false,
  onRowClick: onRowClickFn,
  variant = INPUT_VARIANT._,
  style = {},
  pagination = null,
  setPagination,
  noDataMessage = "No Data Found",
}) => {
  const [rowSelection, setRowSelection] = useState({});
  const [sorting, setSorting] = useState([]);
  const [tableState, setTableState] = useState(null);

  useEffect(() => {}, [data]);

  useEffect(() => {
    if (pagination !== null) {
      setTableState({
        rowSelection,
        // sorting,
        pagination,
      });
    } else {
      setTableState({
        rowSelection,
        // sorting,
      });
    }
  }, [pagination]);

  useEffect(() => {
    if (selected) {
      setRowSelection({});
    }
  }, [selected]);

  // const columns = useMemo(() => {
  //   const columns = headers.map(({ key, text }) => ({
  //     accessorKey: key,
  //     cell: (info) => info.getValue(),
  //     header: text,
  //     // sortingFn: "alphanumeric", // use built-in sorting function by name
  //   }));

  //   return columns;
  // }, [headers]);

  const columns = useMemo(() => {
    return headers.map(({ key, text }) => ({
      accessorKey: key,
      header: text,
      cell: (info) => (
        <div
          style={
            key === "fullAddress"
              ? {
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "600px",
                }
              : {}
          }
          title={info.getValue()} // show full text on hover
        >
          {info.getValue()}
        </div>
      ),
    }));
  }, [headers]);

  const table = useReactTable({
    state: {
      ...tableState,
    },
    rowCount: totalRecords,
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    enableRowSelection: true,
    enableMultiRowSelection: false,
    onRowSelectionChange: setRowSelection,
    // onSortingChange: setSorting,
    enableSorting: false,
    getPaginationRowModel: getPaginationRowModel(),
    onPaginationChange: setPagination,
    manualPagination: true,
  });

  const onRowClick = (event, row, tbindex) => {
    onRowClickFn && onRowClickFn(row.original, tbindex);
    row.getToggleSelectedHandler()(event);
  };

  const getHeaderlength = () => {
    const keyWithArray = "headers";
    const totalLength = table.getHeaderGroups()?.reduce((sum, obj) => {
      return (
        sum + (Array.isArray(obj[keyWithArray]) ? obj[keyWithArray].length : 0)
      );
    }, 0);
    return totalLength;
  };

  const changePage = (e) => {
    const page = parseInt(e) - 1;
    table.setPageIndex(page);
    setPagination((prev) => ({ ...prev, pageIndex: page }));
  };

  return (
    <>
      {/* {JSON.stringify({ sorting, rowSelection })} */}
      <StyledTable
        striped
        bordered
        responsive
        hover
        className={variant}
        style={style}
      >
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  onClick={header.column.getToggleSortingHandler()}
                >
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                  {/* {{
                    asc: " 🔼",
                    desc: " 🔽",
                  }[header.column.getIsSorted()] ?? null} */}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {!isAPiCallLoading &&
            table.getRowModel().rows?.length !== 0 &&
            table.getRowModel().rows.map((row, tbindex) => (
              <tr
                key={row.id}
                onClick={(event) => onRowClick(event, row, tbindex)}
                className={rowSelection[tbindex] && "selected"}
              >
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}

          {!isAPiCallLoading && table.getRowModel().rows?.length === 0 && (
            <NoDataFound>
              <td colSpan={getHeaderlength()}>{noDataMessage}</td>
            </NoDataFound>
          )}
          {isAPiCallLoading && (
            <Loading>
              <td colSpan={getHeaderlength()}>
                <Loader themeMode="light" />
              </td>
            </Loading>
          )}
        </tbody>
      </StyledTable>
      {!isAPiCallLoading && totalRecords !== 0 && (
        <Pagination>
          <PaginationInfo>
            <span>
              Showing{" "}
              {/* {totalRecords > table.getState().pagination.pageSize &&
                (pagination.pageIndex + 1) *
                  table.getState().pagination.pageSize -
                  table.getRowModel().rows.length.toLocaleString() +
                  1 +
                  " - "} */}
              {totalRecords > table.getState().pagination.pageSize &&
                table.getState().pagination.pageSize * pagination.pageIndex +
                  1 +
                  " - "}
              {/* {(pagination.pageIndex + 1) *
                table.getRowModel().rows.length.toLocaleString()} */}
              {totalRecords -
                table.getState().pagination.pageSize * pagination.pageIndex <
              table.getState().pagination.pageSize
                ? totalRecords
                : table.getState().pagination.pageSize * pagination.pageIndex +
                  table.getState().pagination.pageSize * 1}{" "}
              of {table.getRowCount().toLocaleString()} Rows{" "}
            </span>
            <span className="flex items-center gap-1">
              | Page
              <span className="ps-1">
                {table.getState().pagination.pageIndex + 1} of{" "}
                {table.getPageCount().toLocaleString()}
              </span>
            </span>
          </PaginationInfo>
          {pagination !== null &&
          table.getState().pagination.pageSize + table.getRowCount() >=
            table.getState().pagination.pageSize ? (
            <>
              <PaginationRowLimit>
                <span className="per-page-text">per page</span>
                <Select
                  value={table.getState().pagination.pageSize}
                  onChange={(e) => {
                    table.setPageSize(Number(e));
                    changePage(1);
                  }}
                  className="per-page-select"
                  variant="outlined"
                  options={[
                    { value: 10, label: "10" },
                    { value: 25, label: "25" },
                    { value: 50, label: "50" },
                    { value: 100, label: "100" },
                  ]}
                ></Select>
                <span className="records-text">records</span>
              </PaginationRowLimit>
              <PaginationControls>
                <PaginationButtonGroup>
                  <Button
                    className="btn-page-first"
                    onClick={() => table.firstPage()}
                    disabled={!table.getCanPreviousPage()}
                  >
                    <span style={{ display: "flex" }}>
                      <LeftOutlined style={{ marginRight: "-5px" }} />
                      <LeftOutlined />
                    </span>
                  </Button>
                  <Button
                    className="btn-page-prev"
                    onClick={() => table.previousPage()}
                    disabled={!table.getCanPreviousPage()}
                  >
                    <LeftOutlined />
                  </Button>
                  <Button
                    className="btn-page-next"
                    onClick={() => table.nextPage()}
                    disabled={!table.getCanNextPage()}
                  >
                    <RightOutlined />
                  </Button>
                  <Button
                    className="btn-page-last"
                    onClick={() => table.lastPage()}
                    disabled={!table.getCanNextPage()}
                  >
                    <span style={{ display: "flex" }}>
                      <RightOutlined style={{ marginRight: "-5px" }} />
                      <RightOutlined />
                    </span>
                  </Button>
                </PaginationButtonGroup>
                <InputPageChange>
                  <div className="d-flex align-items-baseline">
                    <span className="me-2 go-page-text">| Go to page:</span>
                    <span>
                      <Select
                        variant="outlined"
                        value={pagination.pageIndex + 1}
                        onChange={(e) => {
                          changePage(e);
                        }}
                        disabled={totalRecords < table.getPageCount()}
                        className="go-page-select"
                        options={generateArray(table.getPageCount())?.map(
                          (a) => {
                            return {
                              label: a,
                              value: a,
                            };
                          }
                        )}
                      ></Select>
                    </span>
                  </div>
                </InputPageChange>
              </PaginationControls>
            </>
          ) : (
            ""
          )}
        </Pagination>
      )}
    </>
  );
};

export default Table;
